module.exports = __webpack_public_path__ + "img/1.24b40ff0.jpeg";